<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">

    <div class="col-md-3 col-sm-2">Maintain Asset Report</div>
    <div class="col-md-3 col-sm-2"></div>
    <div class="col-md-3 col-sm-2"></div>
    <!-- <div class="col-md-3 col-sm-3">
      <ol class="breadcrumb cust-bread">
        <li class="breadcrumb-item"><a class="pointer" ><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Asset Report</li>
      </ol>
    </div> -->
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <!-- <div class="container">
      <div class="row">
        <div class="offset-3 col-sm-6 mar-top-15 text-align-center">
          <mat-radio-group aria-label="Select an option">
            <mat-radio-button value="1">All Asset / Asset Type</mat-radio-button>
            <mat-radio-button value="2">By Asset Id</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div> -->
    <div class="offset-3 col-sm-6 mar-top-15">
      <mat-tab-group mat-align-tabs="center">
        <mat-tab label="All Asset / Asset Type">
          <div class="form-group mar-top-9">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected">
              <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
            </select>
          </div>
          <div class="form-group text-align-center">
            <button type="button" [disabled]="isDisabledBtn" class="btn btn-success radius-0 report-button" (click)="downloadAllAssetReport()">Generate</button>
          </div>
        </mat-tab>
        <mat-tab label="By Asset Id">
          <div class="form-group mar-top-9">
            <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
            placeholder="Digital Asset Id">
          </div>
          <div class="form-group text-align-center">
            <button type="button" [disabled]="isDisabledBtn" class="btn btn-success radius-0 report-button" (click)="downloadAssetReportByDescriptionId()">Generate</button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div>
    <div class="table-refresh-container">
      <button type="button" class="btn btn-warning radius-0 refresh-btn matRipple" (click)="getAssetReportTableData()" title="refresh"> <mat-icon>refresh</mat-icon></button>
    </div>
      <div class="card-body card-body-grid">
          <angular-slickgrid gridId='common-grid'
                             (onAngularGridCreated)="angularGridReady($event)"
                             [columnDefinitions]="columnDefinitions"
                             [gridOptions]="gridOptions"
                             [dataset]="dataset"
                             [gridWidth]="1000"
          >
          </angular-slickgrid>

        </div>
  </div>
  
</div>

<notifier-container></notifier-container>

